import type { ModelError } from "@iot-platform/core";
import { NonRecuperableModelError } from "@iot-platform/core";
import type { ReportDetailedStatesDto } from "@report/data/dto/report-detailed-states.dto.ts";
import { ReportDetailedStatesDtoSchema } from "@report/data/dto/report-detailed-states.dto.ts";
import { Report } from "@report/domain/models/report.model";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";

@injectable()
export class ReportDetailedStateMapper {
    map(
        reportDetailedStatesDto: ReportDetailedStatesDto,
    ): Result<Report[], ModelError<typeof Report>> {
        const reportDetailedStatesDtoParsed =
            ReportDetailedStatesDtoSchema.safeParse(reportDetailedStatesDto);

        if (!reportDetailedStatesDtoParsed.success) {
            console.error(reportDetailedStatesDtoParsed.error.issues);
            return err(new NonRecuperableModelError());
        }

        const reportsResults = Object.values(reportDetailedStatesDto.data).map(
            (report) => {
                const station = report.station;
                const reportData = report.data;
                const reportPagination = report.pagination;

                const reportMapped = reportData.map((item) => ({
                    ...item,
                }));

                return Report.createWithRecovery({
                    stationReportSummary: {
                        icon: station.icon,
                        stationId: station.id,
                        stationName: `${station.name} (${station.technical_name})`,
                    },
                    items: reportMapped,
                    pagination: {
                        count: reportPagination.count,
                        current: reportPagination.current,
                        pages: reportPagination.pages,
                        perPage: reportPagination.per_page,
                    },
                });
            },
        );

        if (reportsResults.some((result) => result.isErr())) {
            return err(new NonRecuperableModelError());
        }

        return ok(
            reportsResults
                .map((result) => result.unwrapOr(null))
                .filter(Boolean),
        );
    }
}
